import httpRequest from './config/HttpRequest';
import { COMPANY_API_BASE_URL } from 'constants/config';

export type AdminCompanyListParams = {
  search?: string;
  orderBy?: string; // name
  orderType?: number; // 1 or -1
  pageNo?: number;
  limit?: number;
};

export type AdminCompany = {
  id: string;
  name: string;
  email: string;
  phoneNumber: string;
  address: string;
  timeZone?: string;
  usdot?: string;
  isActive: boolean;
};

export type PaginatedAdminCompanies = {
  data: AdminCompany[];
  total: number;
  last_page: number;
  pageNo: number;
};

export type UpdateCompanyStatus = {
  id: string;
  isActive: boolean;
};

const companiesAdminApi = {
  getCompaniesAdmin: async (params: AdminCompanyListParams): Promise<PaginatedAdminCompanies> => {
    const response = await httpRequest.request({
      baseURL: COMPANY_API_BASE_URL,
      url: '/Companies/admin',
      method: 'GET',
      params,
    });
    return response;
  },

  updateStatus: async (body: UpdateCompanyStatus) => {
    const response = await httpRequest.request({
      baseURL: COMPANY_API_BASE_URL,
      url: `/Companies/status/${body.id}`,
      method: 'PATCH',
      data: { isActive: body.isActive },
    });
    return response;
  },
  getCompanyById: async (companyId: string) => {
    const response = await httpRequest.request({
      baseURL: COMPANY_API_BASE_URL,
      url: `/Companies/admin/${companyId}`,
      method: 'GET',
    });
    return response;
  },
};

export default companiesAdminApi;
